export default __webpack_public_path__ + "static/media/team2.58f4fff8.png";